import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import moment from "moment";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMutation } from "@apollo/client";
//src
import "../../Style/dialogstyle.scss";
import { UPDATE_REQ_PURCHASE } from "../../Schema/Reqpurchase";
import { AuthContext } from "../../Context/AuthContext";
import ListPurchase from "./ListPurchase";
import { SelectSupplier } from "../Include/DynamicSelect";

const UpdateReqPurchase = ({ open, handleClose, editData, setRefetch }) => {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [supplierVal, setSupplierVal] = useState({ id: "", title: "" });

  const [requireField, setRequireField] = useState(false);
  const calculateSubTotal = () => {
    let subTotal = 0;
    listData.forEach((item) => {
      subTotal +=
        (parseFloat(item.unitPrice) || 0) * (parseFloat(item.qty) || 0);
    });
    return subTotal.toFixed(2);
  };

  const listReqPurchMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    unitPrice: 0,
    qty: 0,

    key: Date.now() + Math.random(),
  };

  const [listData, setListData] = useState([listReqPurchMaterial]);

  //updateReqPurchase
  const [updateReqPurchase] = useMutation(UPDATE_REQ_PURCHASE, {
    onCompleted: ({ updateReqPurchase }) => {
      // console.log("updateReqPurchase::", updateReqPurchase)
      setLoading(false);
      if (updateReqPurchase?.status) {
        setAlert(true, "success", updateReqPurchase?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateReqPurchase?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      // console.log("error::", error)
    },
  });

  //formik
  const CheckValidation = Yup.object().shape({
    needDate: Yup.string().required("ទាមទារ!"),
    priority: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
    shippingFee: Yup.number().min(0).required("ទាមទារ!"),
    supplierId: Yup.string().required("ទាមទារ!"),
  });

  const formik = useFormik({
    initialValues: {
      needDate: "",
      priority: "Important",
      remark: "",
      shippingFee: 0,
      supplierId: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            // console.log("element: ", elem)
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.unitPrice > 0 &&
              elem?.qty > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (createStatus) {
        let listReqPurchMaterialToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            unitPrice: d?.unitPrice,
            qty: d?.qty,
            key: d?.key,
          };
        });
        // console.log("values::", values)
        setLoading(true);
        updateReqPurchase({
          variables: {
            id: editData?._id,
            input: {
              ...values,
       
              needDate: moment(values?.needDate).format("YYYY-MM-DD"),
              requestMaterials: listReqPurchMaterialToSubmit,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
  } = formik;

  const total =
    parseFloat(calculateSubTotal()) + parseFloat(values?.shippingFee);

  // console.log("editDatasss::", editData);
  useEffect(() => {
    if (editData) {
      setFieldValue("priority", editData?.priority);
      setFieldValue("needDate", new Date(editData?.needDate));
      setFieldValue("shippingFee", editData?.shippingFee);
      setFieldValue("remark", editData?.remark ?? "");
      setSupplierVal({
        id: editData?.supplierId?._id,
        title: editData?.supplierId?.name,
      });
      setFieldValue("supplierId", supplierVal?.id);
    }

    if (editData?.requestMaterials?.length !== 0) {
      const dataFromBackend = editData?.requestMaterials?.map((d) => {
        // console.log("ddddd",d?.listMaterialUnitId?.imageSrc);
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
          unitPrice: d?.unitPrice,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListData([...dataFromBackend]);
    }
  }, [editData, open]);

  useEffect(() => {
    if (supplierVal?.id) {
      setFieldValue("supplierId", supplierVal?.id ?? "");
    }
  }, [supplierVal?.id]);

  return (
    // <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xl">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតការស្នើទិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">អាទិភាព</Typography>
                <FormControl fullWidth size="small">
                  <Select
                    value={values.priority}
                    onChange={(e) => setFieldValue("priority", e.target.value)}
                  >
                    <MenuItem value="Urgent">​ប្រញ៉ាប់​</MenuItem>
                    <MenuItem value="Important">​សំខាន់​</MenuItem>
                    <MenuItem value="Meduim">​មធ្យម​</MenuItem>
                    <MenuItem value="Low">​តិចតួច​</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">កាលបរិច្ឆេទ</Typography>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  sx={{ bgcolor: "red" }}
                >
                  <DatePicker
                    fullWidth
                    value={values?.needDate}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    onChange={(e) => setFieldValue("needDate", e)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">អ្នកផ្គត់ផ្គង់</Typography>
                <SelectSupplier
                  selectedVal={supplierVal}
                  setSelectedVal={setSupplierVal}
                />
                {!!errors.supplierId && touched.supplierId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.supplierId}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12}>
                <Typography className="dialog-title-view">សម្ភារៈ</Typography>
              </Grid>
              <Grid item xs={12}>
                <ListPurchase
                  listData={listData}
                  setListData={setListData}
                  requireField={requireField}
                  // dialogTitle={dialogTitle}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  size="small"
                  placeholder="ចំណាំ"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" width="100%">
                    <Stack width={"32%"}>
                      <Typography className="total-title">តម្លៃ</Typography>
                    </Stack>
                    <Stack width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {calculateSubTotal()}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">
                        ថ្លៃដឹកជញ្ជូន
                      </Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography>:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={"space-between"}
                      className="total-boz"
                    >
                      <TextField
                        inputProps={{ min: 0 }}
                        className="text-field-right"
                        fullWidth
                        type="number"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .css-1ua80n0-MuiInputBase-input-MuiOutlinedInput-input":
                            { textAlign: "right" },
                        }}
                        {...getFieldProps("shippingFee")}
                        error={Boolean(
                          touched.shippingFee && errors.shippingFee
                        )}
                        helperText={touched.shippingFee && errors.shippingFee}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" width={"100%"}>
                    <Stack justifyContent="center" width={"32%"}>
                      <Typography className="total-title">តម្លៃសរុប</Typography>
                    </Stack>
                    <Stack justifyContent="center" width={"18%"}>
                      <Typography className="total-title">:</Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"50%"}
                      justifyContent={`space-between`}
                      className="total-boz"
                    >
                      <Typography className="total-boz-letter">$</Typography>
                      <Typography className="total-boz-letter">
                        {total ? total.toFixed(2) : "0.00"}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateReqPurchase;
